import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface DollhouseOverlayProps {
  selectedOptionId: string | null;
  isVisible: boolean;
}
export function DollhouseOverlay({
  selectedOptionId,
  isVisible
}: DollhouseOverlayProps) {
  return <AnimatePresence data-id="element-672">
      {isVisible && selectedOptionId === 'fp-base-legal-suite' && <motion.svg initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} viewBox="0 0 1920 1080" className="w-full h-full object-cover transition-all duration-500 object-[70%_center] scale-105 pointer-events-none z-10" style={{
      position: 'absolute',
      right: '-250px'
    }} preserveAspectRatio="xMidYMid slice" data-id="element-673">
          <style data-id="element-674">
            {`
              @keyframes marching-ants {
                to {
                  stroke-dashoffset: -28;
                }
              }
              .marching-ants-path {
                animation: marching-ants 1s linear infinite;
              }
            `}
          </style>
          {/* Approximate polygon for the Legal Suite basement area */}
          <polygon points="550,650 950,500 1350,650 950,800" fill="rgba(0, 200, 255, 0.08)" stroke="rgba(255, 255, 255, 0.9)" strokeWidth="3" strokeDasharray="8 6" className="marching-ants-path" data-id="element-675" />
        </motion.svg>}
    </AnimatePresence>;
}